import React from 'react';
import {RegressionLeastSqrCPU} from 'prophesier/dist/wrapper/index-with-deps-react.min.js';

import Value from 'grommet/components/Value';
import Box from 'grommet/components/Box';
import Select from 'grommet/components/Select';
import Button from 'grommet/components/Button';
import Tiles from 'grommet/components/Tiles';
import NumberInput from 'grommet/components/NumberInput';
import Tile from 'grommet/components/Tile';
import Label from 'grommet/components/Label';
import Anchor from 'grommet/components/Anchor';

const names = ["10 Attempts", "20 Attempts", "30 Attempts"]

const colorPrim = ["rgb(91,100,114)", "rgb(196,175,84)", "rgb(86,130,216)"];

class BubbleSample extends React.Component {
    constructor() {
        super();
        this.state = { 
            title: true,
            legends: true,
            exprt: false,
            m: null,
            b: null,
            r: null,
            x: null,
            y: null,
            sse: null,
            showcomponent: false
             }
        this._onChange = this._onChange.bind(this)
        this._onresult = this._onresult.bind(this)
        this._onpredict = this._onpredict.bind(this)
    }
    componentDidMount() {
        this.setState({showcomponent: true})
    }
    _onChange(field, event) {       
        switch(field) {
            case "predict":
                this.setState({ x: event.target.value})
                break;
        }
    }
    _onresult(event) {
        const {m, b, r, sse} = event.detail;
        this.setState({m, b, r, sse})
    }
    _onpredict(event) {
        //if (event.details.y === NaN) return
        const {y} = event.detail
        this.setState({y})
    }
    render() {
        const {m, b, r, sse, x, y, showcomponent} = this.state

        let m2digits, b2digits, r2digits, y2digits, sse2digits;
        if (m && b && r) {
            m2digits = m.toFixed(2)
            b2digits = b.toFixed(2)
            r2digits = r.toFixed(2)
            sse2digits = sse.toFixed(2)
            y2digits = y ? y.toFixed(2) : "?"
        } else {
            m2digits = "?"
            b2digits = "?"
            r2digits = "?"
            sse2digits = "?"
            y2digits = y ? y.toFixed(2) : "?"
        }
        return (
            <div>
                <h2><strong>Results</strong></h2>
                <Box>	  
                    <Tiles>
                    <h2 style={{paddingTop: "5px"}}><strong>Results</strong></h2>
                        <Tiles fill={true} flush={true} justify="center" responsive={true} selectable={true} size={"small"} onSelect={this._onSelect}>
                            <Tile pad={{"horizontal": "medium"}} colorIndex="light-1" key={0} style={{maxWidth: "300px"}}>
                                <Box pad="small" colorIndex="light">
                                    <Box align="center">
                                    <Value value={r2digits}
                                        label='R square'
                                        size='medium'
                                        responsive={true}
                                    />
                                    </Box>
                                </Box>	
                            </Tile>
                            <Tile pad={{"horizontal": "medium"}} colorIndex="light-1" key={1} style={{maxWidth: "300px"}}>
                                <Box pad="small" colorIndex="light">
                                    <Box align="center">
                                        <Value value={`f(x) = ${m2digits}x + ${b2digits}`}
                                            label='Equation'
                                            size='medium'
                                            responsive={true}
                                        />
                                        </Box>
                                </Box>	
                            </Tile>
                            <Tile pad={{"horizontal": "medium"}} colorIndex="light-1" key={2} style={{maxWidth: "300px"}}>
                                <Box pad="small" colorIndex="light">
                                    <Box align="center">
                                        <Value value={sse2digits}
                                            label='Error'
                                            size='medium'
                                            responsive={true}
                                        />
                                    </Box>
                                </Box>	
                            </Tile>
                        </Tiles>
                    </Tiles>
                </Box>
                {/* <Box direction='row'    
                    align='center'
                    wrap={true}
                    pad='small'
                    margin='none'> 
                    <Label>
                        {"Predict"}
                    </Label>
                    <Box direction='row'
                        align='center'
                        wrap={true}
                        pad='small'
                        margin='none'> 
                            <NumberInput 
                                defaultValue={x} 
                                step={0.1} 
                                onChange={this._onChange.bind(this, 'predict')} />
                    </Box>
                    <Box direction='row'
                        align='center'
                        wrap={true}
                        pad='small'
                        margin='none'
                        style={{paddingLeft: "50px"}}> 
                             <Value value={y2digits}
                                            label='Prediction'
                                            size='medium'
                                            responsive={true}
                            />
                    </Box>
                </Box> */}
                 {(showcomponent) && <RegressionLeastSqrCPU xs={this.props.dataObject[0]} ys={this.props.dataObject[1]} x={x} result={this._onresult} predict={this._onpredict}/>}
            </div>
        );
    }
}

export default BubbleSample;



// WEBPACK FOOTER //
// ./src/samples/run/lrmse.js